angular.module('dpw.directives')
    .factory('userInfoFormatter', [function () {
        return function (user) {
            var userName = user.firstName || '';
            return _.trim(userName);
        };
    }]);
